import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from './ui/Dialog';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Textarea } from './ui/Textarea';
import { ArrowRight } from 'lucide-react';
interface DemoDialogProps {
  children: React.ReactNode;
}
export function DemoDialog({
  children
}: DemoDialogProps) {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    organisation: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Demo request submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <Dialog data-id="element-41">
      <DialogTrigger asChild data-id="element-42">{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[500px] bg-[#09090B] border-white/[0.12] z-[100] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]" data-id="element-43">
        <DialogHeader data-id="element-44">
          <DialogTitle className="text-2xl font-bold text-white font-heading" data-id="element-45">
            Demander une démo
          </DialogTitle>
          <DialogDescription className="text-white/60" data-id="element-46">
            Remplissez ce formulaire et notre équipe vous contactera rapidement
            pour organiser une démonstration personnalisée.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4" data-id="element-47">
          <div className="space-y-2" data-id="element-48">
            <Label htmlFor="demo-nom" className="text-white/70" data-id="element-49">
              Nom *
            </Label>
            <Input id="demo-nom" name="nom" required value={formData.nom} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="Votre nom" data-id="element-50" />
          </div>

          <div className="space-y-2" data-id="element-51">
            <Label htmlFor="demo-email" className="text-white/70" data-id="element-52">
              Email *
            </Label>
            <Input id="demo-email" name="email" type="email" required value={formData.email} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="votre@email.com" data-id="element-53" />
          </div>

          <div className="space-y-2" data-id="element-54">
            <Label htmlFor="demo-organisation" className="text-white/70" data-id="element-55">
              Organisation *
            </Label>
            <Input id="demo-organisation" name="organisation" required value={formData.organisation} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="Votre organisation" data-id="element-56" />
          </div>

          <div className="space-y-2" data-id="element-57">
            <Label htmlFor="demo-message" className="text-white/70" data-id="element-58">
              Message (optionnel)
            </Label>
            <Textarea id="demo-message" name="message" rows={3} value={formData.message} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20 resize-none" placeholder="Parlez-nous de vos besoins..." data-id="element-59" />
          </div>

          <Button type="submit" className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0" data-id="element-60">
            Envoyer la demande
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-61" />
          </Button>
        </form>
      </DialogContent>
    </Dialog>;
}